function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import entityReducerFactory from './factories/entityReducerFactory';
import mapConstants from '../constants/mapConstants';
import applyReducer, { reduceReducers } from './applyReducer';
import formConstants from '../constants/formConstants';
const entityReducer = entityReducerFactory('map');
const initState = {
  initialIndexQuery: _objectSpread(_objectSpread({}, entityReducer.initState.initialIndexQuery), {}, {
    sortDirection: null
  }),
  selectedMarker: null,
  selectedMapType: null,
  clusterItems: null
};

/**
 *  Set cabinet-specific loading and clear updatedFormType when the index call is made
 */
const index = (state, action) => {
  const {
    currentCabinet
  } = state;
  const {
    indexQuery
  } = action;
  const {
    bbox = [0, 0, 0, 0],
    zoom = 0
  } = indexQuery;
  const mapState = _objectSpread(_objectSpread({}, state), {}, {
    updatedFormType: null,
    [currentCabinet]: _objectSpread(_objectSpread({}, state[currentCabinet]), {}, {
      loading: true,
      bbox,
      zoom
    })
  });
  return mapState;
};
const indexSuccess = state => {
  const {
    currentCabinet,
    initialIndexQuery
  } = state;
  const mapState = _objectSpread({}, state);
  const currentMapState = _objectSpread({}, state[currentCabinet]);
  const entityResponseProps = Object.keys(entityReducer.initState);
  entityResponseProps.forEach(prop => {
    // only add entity state to the cabinet-specific property
    currentMapState[prop] = state[prop];

    // remove cabinet-specific entity state from top level
    delete mapState[prop];
  });

  // set the cabinet-specific state to the top-level
  mapState[currentCabinet] = currentMapState;
  mapState.initialIndexQuery = initialIndexQuery;
  return mapState;
};
const clusterItemsSuccess = (state, action) => {
  const data = action.payload || [{
    type: 'FeatureCollection',
    features: []
  }];
  return _objectSpread(_objectSpread({}, state), {}, {
    clusterItems: data[0],
    loading: false
  });
};
const saveSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  updatedFormType: action.data.formType.identifier
});
const setCurrent = (state, {
  currentCabinet
}) => {
  var _state$currentCabinet, _state$currentCabinet2;
  return _objectSpread(_objectSpread({}, state), {}, {
    currentCabinet,
    [currentCabinet]: _objectSpread(_objectSpread({}, state[currentCabinet]), {}, {
      bbox: ((_state$currentCabinet = state[currentCabinet]) === null || _state$currentCabinet === void 0 ? void 0 : _state$currentCabinet.bbox) || [0, 0, 0, 0],
      zoom: ((_state$currentCabinet2 = state[currentCabinet]) === null || _state$currentCabinet2 === void 0 ? void 0 : _state$currentCabinet2.zoom) || 0
    })
  });
};
const setInitialized = (state, action) => {
  const {
    cabinetIdentifier
  } = action;
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      initialized: true
    })
  });
};
const setType = (state, action) => {
  const selectedMapType = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedMapType
  });
};
const setView = (state, action) => {
  const {
    cabinetIdentifier,
    bbox,
    zoom
  } = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      bbox,
      zoom
    })
  });
};
const reducers = {
  [mapConstants.CLUSTER_ITEMS_SUCCESS]: clusterItemsSuccess,
  [mapConstants.CLUSTER_ITEMS_FAILURE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    error: action.error
  }),
  [mapConstants.INDEX]: reduceReducers(entityReducer.reducers[mapConstants.INDEX], index),
  [mapConstants.INDEX_SUCCESS]: reduceReducers(entityReducer.reducers[mapConstants.INDEX_SUCCESS], indexSuccess),
  [mapConstants.SET_CURRENT]: setCurrent,
  [mapConstants.SET_INITIALIZED]: setInitialized,
  [mapConstants.SET_TYPE]: setType,
  [mapConstants.SET_VIEW]: setView,
  [formConstants.SAVE_SUCCESS]: saveSuccess
};
export default applyReducer(reducers, initState);